import ITask from './ITask';
import PIXIRenderer from '../../System/Render/PIXIRenderer';
import TransformComponent from '../../Component/Transform';
import { MapScroll, StarChestFall } from '../../System/Animation/Clip';
import { PlayAnimation } from '../../System/Animation/AnimationHelper';
import { delay } from './TaskQueue';
import PopupTask from './PopupTask';
import Game from '../../Game';
import { PlayerActions } from '../../State/Player/PlayerActions';
import WorldSystem from '../../System/World/WorldSystem';
import { PopupID } from '../../State/UI/PopupID';
import { FTUXType } from 'Player/PlayerProperty/Progress/FTUXType';
import ViewportComponent from 'Component/Map/Viewport';

export default class StarChestFTUXTask implements ITask<WorldSystem> {
    private readonly starChestLevel: number;

    constructor(starChestLevel: number) {
        this.starChestLevel = starChestLevel;
    }

    public *execute(system: WorldSystem): IterableIterator<any> {
        const starChestLevelNode = system.getLevelNode(this.starChestLevel);

        if (!starChestLevelNode) return;

        const currentLevelNode = system.getCurrentLevelNode();

        const screenWidth: number = PIXIRenderer.mapViewport.screenWidth;
        const starChest = starChestLevelNode.find('star_chest');

        // Get positions for scrolling
        const chestPosition = starChestLevelNode.getComponent(TransformComponent).position.clone();
        const currentNodePosition = currentLevelNode.getComponent(TransformComponent).position.clone();

        // Center in screen
        chestPosition.x = -(chestPosition.x - screenWidth / 2);
        currentNodePosition.x = -(currentNodePosition.x - screenWidth / 2);

        // Create scroll clips
        const maxTime = 4000;
        const scrollToChestClip = new MapScroll(starChestLevelNode, {
            position: chestPosition,
            maxTime,
        });
        const scrollToCurrentNodeClip = new MapScroll(currentLevelNode, {
            position: currentNodePosition,
            maxTime,
        });
        // Create popin clip
        const chestPopInClip = new StarChestFall(starChest, {});

        const showPopupTask = new PopupTask(system, {
            popup: PopupID.STAR_CHEST_INFO,
            meta: {},
            delay: 300,
        });

        // fix for SOFA-2689
        system.worldMap.getComponent(ViewportComponent).pause = true;
        yield* PlayAnimation(scrollToChestClip);
        yield* PlayAnimation(chestPopInClip);
        system.worldMap.getComponent(ViewportComponent).pause = false;
        yield* delay(200);
        yield* showPopupTask.execute();
        yield* delay(350);
        yield* PlayAnimation(scrollToCurrentNodeClip);
        system.worldMap.getComponent(ViewportComponent).pause = false;

        PlayerActions.setFTUXUnlocks([FTUXType.STAR_CHEST]);
    }
}
